import {Musician} from '@spout/any-shared/models';

export function isCreatedByLoggedInMusician(uid: string | null, config: {createdBy: Musician}): boolean {
  if (uid && config && config.createdBy && config.createdBy.uid) {
    return uid === config.createdBy.uid;
  }
  return false;
}
